import { render, staticRenderFns } from "./BaseAdmin.vue?vue&type=template&id=a19070ee&scoped=true&"
import script from "./BaseAdmin.vue?vue&type=script&lang=js&"
export * from "./BaseAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdmin.vue?vue&type=style&index=0&id=a19070ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19070ee",
  null
  
)

export default component.exports